export default "__VITE_ASSET__CP27A4Ah__"